import { baseHref } from './base-href';
import { domainPrefix } from './domain-prefix';

/** Creates an asset url without trailing slash using CDN_URL and baseHref */
export const assetUrl = () => `${domainPrefix().slice(0, -1)}${baseHref().slice(0, -1)}/assets`;
